import { createSlice } from "@reduxjs/toolkit";

const loadCartState = () => {
  try {
    const data = localStorage.getItem("myCart");
    return data
      ? JSON.parse(data)
      : {
        myProducts: [],
        info: null,
        info1: null,
        info2: null,
      };
  } catch {
    return {
      myProducts: [],
      info: null,
      info1: null,
      info2: null,
    };
  }
};

const saveCartState = (state) => {
  localStorage.setItem("myCart", JSON.stringify(state));
};

export const myCartSlice = createSlice({
  name: "myCart",
  initialState: loadCartState(),
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;

      const exists = state.myProducts.some(
        item => item.id === product.id
      );

      if (!exists) {
        state.myProducts.push({ ...product, quantity: 1 });
      }

      saveCartState(state);
    },

    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      console.log(id);

      const product = state.myProducts.find(item => item.id === id);

      if (product) {
        product.quantity = quantity;
      }

      saveCartState(state);
    },

    removeFromCart: (state, action) => {
      state.myProducts = state.myProducts.filter(
        item => item.id !== action.payload
      );

      saveCartState(state);
    },

    setInfo: (state, action) => {
      state.info = action.payload;
      saveCartState(state);
    },

    setInfo1: (state, action) => {
      state.info1 = action.payload;
      saveCartState(state);
    },

    setInfo2: (state, action) => {
      state.info2 = action.payload;
      saveCartState(state);
    },

    clearCart: (state) => {
      state.myProducts = [];
      state.info = null;
      state.info1 = null;
      state.info2 = null;
      saveCartState(state);
    }
  },
});

export const {
  addToCart,
  removeFromCart,
  updateQuantity,
  setInfo,
  setInfo1,
  setInfo2,
  clearCart
} = myCartSlice.actions;

export default myCartSlice.reducer;
